import { render, staticRenderFns } from "./DashbordStaffView.vue?vue&type=template&id=ece9dce6&scoped=true"
import script from "./DashbordStaffView.vue?vue&type=script&lang=js"
export * from "./DashbordStaffView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece9dce6",
  null
  
)

export default component.exports